<script setup>
import 'v-calendar/dist/style.css';
import {ref, computed} from "vue"
import DayDetail from '@/components/Attendance/DayDetail.vue'
import ApplyPunch from '@/components/ApplyPunch.vue'
import { useToast } from "vue-toastification"

const maxDate = computed(()=> dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD'))
const toast = useToast()

const year = ref(null)
const month = ref(null)
const dayInfo = ref({
    workHours: 0,
    current: new Date(),
    isWorkDay: true,
    leaves: [],
    punches: []
})

const canApplyDate = computed(() => {
    const day = dayjs(dayInfo.value.current)
    const lastApplyDate = dayjs().date() > 5
        ? dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        : dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
    return day.isAfter(lastApplyDate) && day.isSameOrBefore(dayjs())
})

const showModal = ref(false)

const showApplyPunch = ref(false)
const today = {
    key: 'today',
    highlight: {
        color: 'purple',
        fillMode: 'outline'
    },
    dates: dayInfo.value.current,
}
const dayStyleMap = {
    rest: {
        color: 'gray',
        fillMode: 'light'
    },
    leave: {
        color: 'gray',
        fillMode: 'outline'
    },
    punch: {
        color: 'green',
        fillMode: 'outline'
    },
    incomplete: {
        dot: 'red',
    },
    noPunch: {
        color: 'red',
        fillMode: 'solid'
    },

}
const attributes = ref([])

async function dayClick(day) {
    await pickDay(dayjs(day.date).format('YYYY-MM-DD'))
}

async function pickDay(day) {
    const data = await axios.get(`/api/day?date=${day}`)
    const result = data.data
    dayInfo.value.workHours = result.workHours
    dayInfo.value.current = result.day
    dayInfo.value.isWorkDay = result.isWorkDay
    dayInfo.value.leaves = result.leaves
    dayInfo.value.punches = result.punches
}

async function formatDay(days, type) {
    const formattedDays = []
    for(const day of days) {
        if (type === 'noPunch' && dayjs().isAfter(dayjs(`${year.value}-${month.value}-${day}`))) {
            formattedDays.push(new Date(year.value, month.value - 1, day))
        }
        if (type !== 'noPunch') {
            formattedDays.push(new Date(year.value, month.value - 1, day))
        }
    }
    return {
        highlight: {
            color: dayStyleMap[type]?.color,
            fillMode: dayStyleMap[type]?.fillMode,
        },
        dot: dayStyleMap[type]?.dot,
        bar: dayStyleMap[type]?.bar,
        dates: formattedDays,
    }
}

async function fetchDays(year, month) {
    attributes.value = []
    try {
        const {data} = await axios.get(`/api/calendar?year=${year}&month=${month}`)
        if (data.data.leaveDays.length) {
            attributes.value.push(await formatDay(data.data.leaveDays, 'leave'))
        }
        if (data.data.restDays.length) {
            attributes.value.push(await formatDay(data.data.restDays, 'rest'))
        }
        if (data.data.incompleteDays.length) {
            attributes.value.push(await formatDay(data.data.incompleteDays, 'incomplete'))
        }
        if (data.data.noPunchDays.length) {
            attributes.value.push(await formatDay(data.data.noPunchDays, 'noPunch'))
        }
        attributes.value.push(today)
    } catch (e) {
        toast.error(e.response.data.message)
    }
}

async function reFreshCalendar() {
    await fetchDays(year.value, month.value)
}

async function changeMonth(e) {
    if (year.value !== e.year || month.value !== e.month) {
        year.value = e.year
        month.value = e.month
        await fetchDays(e.year, e.month)
        dayInfo.value.current = null
    }
}

async function closeModal() {
    showModal.value = false
    await pickDay(dayjs(dayInfo.value.current).format('YYYY-MM-DD'))
    await fetchDays(year.value, month.value)
}


</script>

<template>
    <v-calendar
        is-expanded
        @dayclick="dayClick"
        min-date="2022-03-01"
        :max-date="maxDate"
        @update:to-page="changeMonth"
        :attributes="attributes"
    />
    <DayDetail
        :dayInfo="dayInfo"
        @reFreshCalendar="reFreshCalendar"
        @pickDay="pickDay"
    />
    <template
        v-if="dayInfo.workHours < 8 && dayInfo.current && canApplyDate && dayInfo.isWorkDay"
    >
        <div class="flex items-center justify-center mt-2">
            <div class="text-sm">work hours <span class="text-rose-400">{{ dayInfo.workHours }}</span></div>
        </div>
        <div class="flex justify-center mt-2">
            <vue-final-modal
                v-model="showModal"
                classes="flex justify-center items-center"
            >
                <ApplyPunch
                    :day="dayInfo.current"
                    @close="closeModal"

                />
            </vue-final-modal>
            <button
                class="px-2 py-1 text-white bg-indigo-400 rounded cursor-pointer"
                @click="showModal = true"
            >Apply Punch
            </button>
        </div>
    </template>
</template>


